/*
 * @Author: huangdingkun huangdingkun@redbirdedu.com
 * @Date: 2023-01-06 15:54:32
 * @LastEditors: huangdingkun huangdingkun@redbirdedu.com
 * @LastEditTime: 2023-02-09 10:04:35
 * @FilePath: \web\src\pages\user\AccountPage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import UserEditPage from "./UserEditPage";

class AccountPage extends React.Component {
  render() {
    return (
      <UserEditPage history={this.props.history} organizationId={this.props.account.owner} userName={this.props.account.name} account={this.props.account} location={this.props.location} />
    );
  }
}

export default AccountPage;
